import React, {useState, useEffect} from 'react';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import ArrButton, {AurButtonProps} from '../arr-button/ArrButton';

export interface ArrSelectButtonProps extends Omit<
  AurButtonProps,
  'startIcon' | 'endIcon' | 'progressCircleSize' | 'loading' | 'target'
> {
  dataTestId: string;
  options: string[];
  defaultOption?: string;
  onSelectionChange: (option: string) => void;
}

const ArrSelectButton: React.FC<ArrSelectButtonProps> = ({
  dataTestId = 'arr-select-btn',
  options = [''],
  defaultOption,
  onSelectionChange,
  ...props
}) => {
  const [currentOption, setCurrentOption] = useState<string>(options[0]);

  useEffect(() => {
    if (defaultOption) {
      const defaultIndex = options.indexOf(defaultOption);
      setCurrentOption(options[defaultIndex]);
    }
  }, []);

  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    const currentIndex = options.indexOf(currentOption);
    const newIndex = currentIndex < options.length - 1 ? currentIndex + 1 : 0;

    const newOption = options[newIndex];
    setCurrentOption(newOption);
    onSelectionChange && onSelectionChange(newOption);
    props.onClick && props.onClick(event);
  };

  return (
    <ArrButton
      startIcon={<SwapHorizIcon data-testid={`${dataTestId}-swap-icon`} />}
      dataTestId={dataTestId}
      title={currentOption}
      onClick={handleClick}
      {...props}
    >
      {currentOption}
    </ArrButton>
  );
};

export default ArrSelectButton;
